import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Markdown from 'markdown-to-jsx';
import SVBChecklistHeader from './SVBChecklistHeader';
import {
  SVBTypography,
  // SVBTextLink
} from '@svb/svb-react-components';
import IntegrationCheckbox from './IntegrationCheckbox';
import Loading from '@svb/api-loading-component/dist/components/index';
import { getIntegrationChecklist } from './helper';
import { SVBFaqApiContextualSupport } from '@svb/portal-ui-react-components';
import { useStore } from '../../core/useStore';
import MetaTags from '../../core/MetaTags';
import { SVBErrorPageRenderer } from '../../helpers/utilityFunctions';

const CheckListPhaseContainer = ({ children }) => {
  return (
    <section className='svb-checklist-phase-container container svb-container-fixed pb-5 pt-3 ps-4'>
      {children}
    </section>
  );
};

const ChecklistTitle = ({ title, underline }) => {
  return (
    <div className='mb-4 mt-4'>
      <SVBTypography type='heading-medium'>{title}</SVBTypography>
      <div className={`svb-checklist-phase-border svb-checklist-phase-border-${underline}`}></div>
    </div>
  );
};

const ChecklistOption = ({ id, name, value, label, labelLink, pathLink }) => {
  const linkStartIndex = label.indexOf(labelLink);
  const linkEndIndex = linkStartIndex + labelLink?.length;
  return (
    <div className='svb-checklist-option-container mb-3'>
      <IntegrationCheckbox
        name={name}
        id={id}
        value={value}
        label={
          <>
            {label.substring(0, linkStartIndex)}
            {labelLink && pathLink ? (
              <Link to={pathLink || ''} className='svb-text-link info no-href'>
                {labelLink || ''}
                {/* <SVBTextLink text={labelLink || ''} /> */}
              </Link>
            ) : (
              ''
            )}
            {label.substring(linkEndIndex)}
          </>
        }
        defaultChecked={false}
        extraClasses='m-1 me-2 paragraph d-flex'
      />
    </div>
  );
};

const Checklist = (props) => {
  const { dataTestId, testMockData } = props;
  const [loading, setLoading] = useState(true);
  const [ismounted, setIsmounted] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorStatusCode, setErrorStatusCode] = useState('');
  const [errorDefaultMessage, setErrorDefaultMessage] = useState(
    'It happens sometimes, you may refresh the page or go to home.',
  );
  let url = props?.contentUrl ? props?.contentUrl : '';
  const checkListInt = dataTestId
    ? testMockData
    : getIntegrationChecklist(url, 'integration-checklist.md');
  const supportFaqsItems = useStore((state) => state.faqsItems);
  //const checkListInt = Utils.getFileContent('/checklist/checklist-page.md');
  useEffect(() => {
    setIsmounted(true);
  }, []);

  useEffect(() => {
    setIsError(false);
    if (checkListInt.type === 'success') {
      setLoading(false);
    }
    if (checkListInt.type === 'error') {
      setIsError(true);
      setErrorStatusCode(checkListInt?.errorStatusCode);
      !checkListInt?.errorStatusCode && setErrorDefaultMessage(checkListInt?.response);
      setLoading(false);
    }
  }, [checkListInt]);

  if (isError) {
    return (
      <SVBErrorPageRenderer
        errorStatusCode={errorStatusCode}
        defaultErrorMessage={errorDefaultMessage}
      />
    );
  }
  // if (checkListInt?.response) {
  return (
    <>
      {/*Generate metadata once component/template mounts */}
      {ismounted && (
        <MetaTags
          title={'Integration Checklist'}
          sitename={'SVB Developer Portal'}
          description={
            "SVB's recommended steps to guide you through your development process. Check them off before launching your app in Production"
          }
          image={window.location.protocol + '//' + window.location.host + '/svb_fcb_logo_new.svg'}
          keywords={
            'svb, silicon valley bank, api, developer, portal, integration, fcb, first citizens, getting started'
          }
          type='website'
          author='Silicon Valley Bank'
        />
      )}

      {/*render page elements once data is available */}
      {checkListInt === 'No Content' || loading ? (
        <div className='solutions-loading'>
          <Loading />
        </div>
      ) : (
        <>
          <Markdown
            options={{
              overrides: {
                Hero: {
                  component: SVBChecklistHeader,
                  props: props,
                },
                Title: {
                  component: ChecklistTitle,
                },
                PhaseContainer: {
                  component: CheckListPhaseContainer,
                },
                Checkbox: {
                  component: ChecklistOption,
                },
                ol: {
                  props: {
                    className: 'paragraph',
                  },
                },
                ul: {
                  props: {
                    className: 'paragraph',
                  },
                },
              },
            }}
          >
            {checkListInt?.response}
          </Markdown>
          <div className='common-contextual-support'>
            <SVBFaqApiContextualSupport
              filterOption={{
                resultCount: 3,
                filterType: 'topics',
                filterValue: ['General'],
                filterDisplayName: 'general',
              }}
              faqsData={supportFaqsItems}
              extraClasses='container svb-container-fixed mb-10 pb-10'
            />
          </div>
        </>
      )}
    </>
  );
  // }
};

export default Checklist;
